import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReviewBoardsCreate, ReviewBoardsDelete, ReviewBoardsRefresh, ReviewBoardsRefreshByID, ReviewBoardsUpdate } from './review-boards.action';
import { ReviewsService } from '../../reviews.service';
import { ReviewBoard } from '../../reviews.models';
import { A } from '@angular/cdk/keycodes';

export class ReviewBoardsStateModel {
  data: ReviewBoard[] = [];
}

@State<ReviewBoardsStateModel>({
  name: 'ReviewBoards',
  defaults: {
    data: []
  }
})
@Injectable()
export class ReviewBoardsState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ReviewsService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ReviewBoardsStateModel) {
    return state.data;
  }

  @Action(ReviewBoardsRefresh)
  refresh({ patchState }: StateContext<ReviewBoardsStateModel>) {
    this._service.getReviewBoards().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(ReviewBoardsRefreshByID)
  refreshByID({ getState, patchState }: StateContext<ReviewBoardsStateModel>, { id }: ReviewBoardsRefreshByID) {
    this._service.getReviewBoardById(id).toPromise().then(data => {
      if (data) {
        const state = getState();
        const index = state.data.map(x => x.id).indexOf(data.id);
        if (index >= 0) {
          state.data.splice(index, 1);
        }
        patchState({
          data: [...getState().data, data]
        });
      }
    });
  }

  @Action(ReviewBoardsCreate)
  create({ getState, patchState }: StateContext<ReviewBoardsStateModel>, { item }: ReviewBoardsCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ReviewBoardsUpdate)
  update({ getState, patchState }: StateContext<ReviewBoardsStateModel>, { id, item }: ReviewBoardsUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ReviewBoardsDelete)
  delete({ getState, patchState }: StateContext<ReviewBoardsStateModel>, { id }: ReviewBoardsDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
